/* global ViddlerEmbed */
import React from 'react';

/**
 * Video Component
 */
export default class Video extends React.Component {
  static propTypes = {
    id: React.PropTypes.string.isRequired,
    videoId: React.PropTypes.string.isRequired,
    videoReadyCallback: React.PropTypes.func,
    width: React.PropTypes.string,
  };

  static defaultProps = {
    width: '100%',
  };

  /**
   * Video Component Constructor
   * @param  {Object} props Passed in properties
   * @return {Undefined} Returns nothing
   */
  constructor(props) {
    super(props);

    /**
     * Instance of the Viddler Player
     * @type {Object}
     */
    this.player = null;

    /**
     * The selector that Viddler will use to mount the player
     * @type {String}
     */
    this.selector = this.getId(props.id);

    /**
     * The height of the video - used to prevent the modal resizing to zero
     * @type {Number}
     */
    this.videoHeight = 300;

    this.videoReadyCallback = this.videoReadyCallback.bind(this);
  }

  /**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */
  componentDidMount() {
    this.refs.videoContainer.style.height = `${this.videoHeight}px`;
    this.player = new ViddlerEmbed({
      target: `#${this.selector}`,
      videoId: this.props.videoId,
      width: this.props.width,
    });
    this.player.manager.events.on('gui:ready', this.videoReadyCallback);
  }

  /**
   * Lifecycle Method
   * @param {Object} newProps The new passed in props
   * @return {Undefined} Returns nothing
   */
  componentWillReceiveProps(newProps) {
    if (this.props.videoId !== newProps.videoId) {
      this.refs.videoContainer.style.height = `${this.videoHeight}px`;
      this.refs.videoContainer.innerHTML = '';
    }
  }

  /**
   * Lifecycle Method
   * @param {Object} prevProps The previous passed in props
   * @return {Undefined} Returns nothing
   */
  componentDidUpdate(prevProps) {
    if (this.props.videoId !== prevProps.videoId) {
      this.player = new ViddlerEmbed({
        target: `#${this.selector}`,
        videoId: this.props.videoId,
        width: this.props.width,
      });
      this.player.manager.events.on('gui:ready', this.videoReadyCallback);
    }
  }

  /**
   * Lifecycle Method
   * @return {Undefined} Returns nothing
   */
  componentWillUnmount() {
    this.player = null;
  }

  /**
   * Constructs the id selector for the Viddler player
   * @param  {String} id The main id
   * @return {String} The constructed id
   */
  getId(id) {
    const displayId = id ? id : 'Video';

    return `${displayId}_video`;
  }

  /**
   * Callback for Viddler for when it's ready to play
   * @return {Undefined} Returns nothing
   */
  videoReadyCallback() {
    if (this.refs.videoContainer) {
      this.videoHeight = this.refs.videoContainer.clientHeight;
      this.refs.videoContainer.style.height = 'auto';

      if (this.props.videoReadyCallback) {
        this.props.videoReadyCallback();
      }
    }
  }

  /**
   * React Component render
   * @return {JSX} Video rendered
   */
  render() {
    return <div id={this.selector} ref="videoContainer" />;
  }
}



// WEBPACK FOOTER //
// ./src/reactModules/shared/library/Video/Video.js